import { Modal } from "antd";
import axios from "axios";
import { Component } from 'react';
import { Button, Card, Col, Form, Nav, OverlayTrigger, Row, Tab, Tooltip } from "react-bootstrap";
import CommonLoader from '../loaderComponent/CommonLoader';
import CommonToast from '../Toaster/CommonToast';
// import { ThemeProvider } from '@material-ui/core'
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
// import { downloadCSV } from '../../utils/csvDownload';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { exportAttendanceCsv } from "../../utils/exportAttendanceCsv";
import { hasPermission } from './../../utils/usePermission';
import { DateTimeFormat } from './../DateFormat/DateTimeFormat';
import AttendanceByEmp from './AttendanceByEmp';


export default class AttendanceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      completed: false,
      startDate: '',
      endDate: '',
      color: '',
      project: "",
      projects: [],
      date: new Date().toISOString().split("T")[0],
      attendanceList: [],
      loading: true,
      hasError: false,
      selectedAttendance: null,
      showModal: false,
      username: "",
      password: "",
      showPassword: false,
      isCsvLoading: false,
      showExcelButton: false
    };
  }

  handleFilterChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  async componentDidMount() {
    let token = localStorage.getItem('token');
    axios({
      method: "get",
      url: "/checkToken",
      headers: { "Authorization": `Bearer ${token}` }
    })
      .then((res) => {
        this.setState({ isAuthenticated: true, loading: false, username: res.data.authData.user.username });
        // console.log("this is response", this.state.username)
      })
      .catch((err) => {
        console.log(err);
        console.log(`Access: ${this.state.isAuthenticated}`);
      });
    this.fetchAttendanceData();
    this.fetchProjectData();
  }


  // csvDownload = () => {
  //   const { attendanceList } = this.state;
  //   console.log("csv data is:", attendanceList);
  //   exportAttendanceCsv(attendanceList, "project"); // month and year can be dynamic
  // };

  csvDownload = async () => {

    const { attendanceList, startDate, endDate } = this.state;
    // console.log("csv data is:", attendanceList);
    // console.log("csv data is startDate:", startDate);
    // console.log("csv data is endDate:", endDate);

    this.setState({ isCsvLoading: true });

    try {
      await exportAttendanceCsv(attendanceList, "project", startDate, endDate);
    } catch (error) {
      console.error("CSV export failed", error);
    } finally {
      this.setState({ isCsvLoading: false });
    }
  };

  fetchProjectData = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/project', { headers });
      this.setState({ projects: response?.data });
      setTimeout(() => {
        this.setState({ loading: false });
      }, 900);
    } catch (error) {
      console.error("Error fetching project:", error);
      let errorMessage = "Failed to load project.";

      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  };
  fetchAttendanceData = async () => {
    const { project, startDate, endDate } = this.state;

    if (!startDate || !endDate) {
      this.setState({ hasError: true, errMsg: "Please select a Date Range." });
      return;
    }

    this.setState({ loading: true });

    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    };

    let requestData = { startDate, endDate };

    if (project && project !== "all") {
      requestData.projectId = project;
    }

    try {
      const response = await axios.post("/attendance/attendanceByDateRange", requestData, { headers });
      this.setState({ attendanceList: response.data, loading: false, showExcelButton: true });
    } catch (error) {
      console.error("Error fetching attendance:", error);
      let errorMessage = "Failed to load attendance list.";
      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  };



  updateAttendance = (data) => {
    this.setState({ showModal: true, selectedAttendance: { ...data } });
  };

  processAttendance = async (attendanceData) => {
    console.log("attendanceData", attendanceData);
  };

  handleConfirm = () => {
    this.setState({ showModal: true });
  };




  // handleInputChange = (event) => {
  //   const { name, value } = event.target;
  //   if (name === "password") {
  //     this.setState({
  //       [name]: value,
  //     });
  //   } else {
  //     this.setState((prevState) => ({
  //       selectedAttendance: {
  //         ...prevState.selectedAttendance,
  //         [name]: value,
  //       },
  //     }));
  //   }
  // };

  calculateHours = (startTime, endTime) => {
    if (!startTime || !endTime) return "";

    const start = startTime.split(":").map(Number);
    const end = endTime.split(":").map(Number);

    const startSeconds = start[0] * 3600 + start[1] * 60 + (start[2] || 0);
    const endSeconds = end[0] * 3600 + end[1] * 60 + (end[2] || 0);

    let diff = endSeconds - startSeconds;

    if (diff < 0) {
      diff += 24 * 3600;
    }

    const hours = (diff / 3600).toFixed(2);
    return hours;
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;


    if (name === "password") {
      this.setState({ password: value });
      return;
    }


    this.setState((prevState) => {
      const updatedAttendance = {
        ...prevState.selectedAttendance,
        [name]: value,
      };

      if (name === "startTime" || name === "endTime") {
        updatedAttendance.numberOfHours = this.calculateHours(
          updatedAttendance.startTime,
          updatedAttendance.endTime
        );
      }

      return { selectedAttendance: updatedAttendance };
    });
  };


  handleConfirmUpdate = () => {
    Modal.confirm({
      title: "Are you sure you want to update attendance?",
      content: "Please confirm before proceeding.",
      onOk: () => {
        this.setState({ showPasswordField: true });
      },
      onCancel: () => {
        this.setState({ showPasswordField: false });
      },
      okText: "Yes, Update",
      cancelText: "Cancel",
    });
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  handleUpdateAttendance = async () => {

    const { selectedAttendance, password, showPasswordField } = this.state;

    if (!showPasswordField) {
      // If password field is not yet shown, show confirmation first
      this.handleConfirmUpdate();
      return;
    }

    if (!password) {
      this.setState({ showToast: true, toastMessage: "Please enter a password before updating attendance.", toastVariant: "danger", color: 'red' });
      return;
    }

    const attendancePayload = {
      id: selectedAttendance?.id,
      startTime: selectedAttendance?.startTime,
      endTime: selectedAttendance?.endTime,
      username: this.state.username,
      password: password
    };

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", showModal: false });
        return;
      }

      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(`/attendance/updatepass`, attendancePayload, { headers });

      if (response.status === 200) {
        this.setState({
          showToast: true,
          toastMessage: "Attendance updated successfully",
          toastVariant: "success",
          color: 'green',
          showModal: false,
          showPasswordField: false,
          password: ""
        });
        this.fetchAttendanceData(); // Refresh data
      } else {
        this.setState({ showToast: true, toastMessage: "Failed to update attendance", toastVariant: "danger", color: 'red' });
      }
    } catch (error) {
      console.error("Error updating attendance:", error);
      this.setState({ showToast: true, toastMessage: "Invalid Credentials ", toastVariant: "danger", color: 'red' });
    }
  };

  handleAddAttendance = () => {
    this.props.history.push("/add-attendance");
  };


  renderTable = (attendanceList, employee) => {
    return (

      <div className="col-sm-12">
        <Card>
          <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
            <div className="panel-title">
              <strong>Employee Attendance List By Project</strong>
            </div>
          </Card.Header>
          <Card.Body>
            <Form className="mb-3">
              <Row className="align-items-end">
                {/* Project Filter */}
                <Col xs={12} sm={6} md={3}>
                  <Form.Group controlId="project">
                    <Form.Label>Project</Form.Label>
                    <Form.Control
                      as="select"
                      className="form-select"
                      name="project"
                      value={this.state.project}
                      onChange={this.handleFilterChange}
                    >
                      <option value="">Select Project</option>
                      <option value="all">All Projects</option>
                      {this.state.projects.map((project) => (
                        <option key={project.id} value={project.id}>
                          {project.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                {/* Start Date */}
                <Col xs={12} sm={6} md={3}>
                  <Form.Group controlId="startDate">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="startDate"
                      value={this.state.startDate}
                      onChange={this.handleFilterChange}
                    />
                  </Form.Group>
                </Col>

                {/* End Date */}
                <Col xs={12} sm={6} md={3}>
                  <Form.Group controlId="endDate">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="endDate"
                      value={this.state.endDate}
                      onChange={this.handleFilterChange}
                    />
                  </Form.Group>
                </Col>

                {/* Buttons */}
                <Col xs={12} sm={6} md={3} className="d-flex gap-2">
                  {hasPermission('M11B3') && (
                    <Button
                      variant="outline"
                      className="me-2 info"
                      onClick={this.fetchAttendanceData}
                    >
                      <i className="fa fa-search"></i>
                    </Button>
                  )}
                  {hasPermission('M11B4') && (

                    <Button
                      variant="outline"
                      className='info'
                      onClick={this.csvDownload}
                      disabled={
                        !this.state.showExcelButton ||
                        this.state.isCsvLoading ||
                        !this.state.project ||
                        (!this.state.startDate &&
                          !this.state.endDate &&
                          this.state.project !== "all")
                      }
                    >
                      {this.state.isCsvLoading ? (
                        <>
                          <i className="fas fa-spinner fa-spin me-1"></i> Downloading...
                        </>
                      ) : (
                        <i className="fas fa-file-csv"></i>
                      )}
                    </Button>
                  )}
                </Col>
              </Row>
            </Form>

            {/* Attendance Table */}
            <ThemeProvider theme={createTheme()}>
              <MaterialTable
                columns={[
                  { title: 'EMP ID', field: 'empid' },
                  {
                    title: 'Project Name', field: 'projectName',
                    cellStyle: { minWidth: 250 },
                    headerStyle: { minWidth: 250 }
                  },
                  {
                    title: 'Name', field: 'employeeName',
                    cellStyle: { minWidth: 250 },
                    headerStyle: { minWidth: 250 }
                  },
                  {
                    title: 'Date', field: 'date',
                    render: (value) => DateTimeFormat(value.date),
                    cellStyle: { minWidth: 150 },
                    headerStyle: { minWidth: 150 }
                  },
                  {
                    title: 'In Time', field: 'startTime',
                    cellStyle: { minWidth: 100 },
                    headerStyle: { minWidth: 100 }
                  },
                  {
                    title: 'Out Time', field: 'endTime',
                    cellStyle: { minWidth: 100 },
                    headerStyle: { minWidth: 100 }
                  },
                  {
                    title: 'Working Hours',
                    field: 'numberOfHours',
                    render: rowData => {
                      return rowData?.numberOfHours ? (
                        <div className="round_attendance">
                          {rowData.numberOfHours}
                        </div>
                      ) : <div className="round_attendance_zero">0</div>;

                    }
                  },
                  {
                    title: 'OT (Hours)',
                    field: 'ot_hours',
                    render: rowData => {
                      return rowData?.ot_hours ? (
                        <div className="round_attendance">
                          {rowData.ot_hours}
                        </div>
                      ) : <div className="round_attendance_zero">0</div>;

                    }
                  },

                  // { title: 'OT Hours', field: 'ot_hours' },
                  {
                    title: 'Location',
                    field: 'location',
                    render: rowData => {
                      try {
                        const location = JSON.parse(rowData.location);
                        if (location.latitude && location.longitude) {
                          return `Latitude: ${location.latitude}, Longitude: ${location.longitude}`;
                        }
                      } catch (error) {
                        return rowData.location;
                      }
                    },
                    cellStyle: { width: '250px', minWidth: '250px', textAlign: 'center' },
                    headerStyle: { width: '250px', minWidth: '250px', textAlign: 'center' },
                  },
                  {
                    title: 'Action',
                    render: rowData =>
                      hasPermission('M11B1') && (
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Update Attendance</Tooltip>}
                        >
                          <Button
                            size="sm"
                            variant="outline-info"
                            className='info'
                            onClick={() => this.updateAttendance(rowData)}
                          >
                            <i className="fas fa-edit"></i>
                          </Button>
                        </OverlayTrigger>
                      ),
                  },
                ]}
                data={attendanceList
                  .map(({ tableData, ...rest }) => rest)
                  .sort((a, b) => a.employeeName.localeCompare(b.employeeName))}
                // data={attendanceList.map(({ tableData, ...rest }) => rest)/}
                options={{
                  rowStyle: (rowData, index) => ({
                    backgroundColor: index % 2 ? '#f2f2f2' : undefined,
                  }),
                  pageSize: 10,
                  pageSizeOptions: [10, 20, 30, 50, 75, 100],
                }}
                title="Attendance List"
              />
            </ThemeProvider>
          </Card.Body>
        </Card>
      </div >


    );
  };

  render() {


    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          <div className="pt-4">
            <div className='add-btn-attendance'>
              {
                hasPermission('M11B2') &&
                <Button type="button" variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleAddAttendance}> <i className="fa fa-plus-circle"></i> Add Attendance</Button>
              }
            </div>
            <Tab.Container defaultActiveKey="project">
              <Nav variant="tabs">
                <Nav.Item>
                  <Nav.Link eventKey="project">Project Wise</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="employee">Employee Wise </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="project">
                  {this.renderTable(this.state.attendanceList, false)}</Tab.Pane>
                <Tab.Pane eventKey="employee">
                  <AttendanceByEmp />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
          <Modal
            title="Update Attendance"
            open={this.state.showModal}
            onCancel={() => this.setState({ showModal: false, showPasswordField: false })}
            onOk={this.handleUpdateAttendance}
            okText={this.state.showPasswordField ? "Save" : "Confirm Update"}
            cancelText="Cancel"
          >
            {this.state.selectedAttendance && (
              <Form>
                {this.state.showPasswordField && (
                  <Form.Group>
                    <Form.Label className='required'>Enter Password</Form.Label>
                    <div style={{ position: "relative" }}>
                      <Form.Control
                        type={this.state.showPassword ? "text" : "password"}
                        onChange={this.handleInputChange}
                        value={this.state.password}
                        name="password"
                        placeholder="Enter Your Login Password"
                        required
                      />
                      <span
                        onClick={this.togglePasswordVisibility}
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "10px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#6c757d"
                        }}
                      >
                        {this.state.showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    {/* <Form.Control
                      type="password"
                      onChange={this.handleInputChange}
                      value={this.state.password || ""}
                      name="password"
                      placeholder='Enter Your Login Password'
                      required
                    /> */}
                  </Form.Group>

                )}
                {
                  !this.state.showPasswordField && (
                    <>
                      <Form.Group>
                        <Form.Label>Employee ID</Form.Label>
                        <Form.Control type="text" value={this.state.selectedAttendance.empid} readOnly />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Employee Name</Form.Label>
                        <Form.Control type="text" value={this.state.selectedAttendance.employeeName} readOnly />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Start Time</Form.Label>
                        <Form.Control
                          type="time"
                          step="1"
                          name="startTime"
                          value={this.state.selectedAttendance.startTime}
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>End Time</Form.Label>
                        <Form.Control
                          step="1"
                          type="time"
                          name="endTime"
                          value={this.state.selectedAttendance.endTime}
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Number of Hours</Form.Label>
                        <Form.Control type="text" value={this.state.selectedAttendance.numberOfHours} readOnly />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Location</Form.Label>
                        <Form.Control as="textarea"
                          rows={3} value={this.state.selectedAttendance.location} readOnly />
                      </Form.Group>
                    </>)}
              </Form>
            )}
          </Modal>
        </CommonLoader>
      </>
    );
  }
}
